import React from "react"
import { isRouteErrorResponse, useRouteError } from "react-router-dom"

export default function AppErrorBoundary() {
  const error = useRouteError()

  let title = "Something went wrong"
  let description: string | React.ReactNode = "An unexpected error occurred. Please try again."

  if (isRouteErrorResponse(error)) {
    title = `Error ${error.status}`
    description = error.statusText || "A routing error occurred"
  } else if (error instanceof Error) {
    title = error.name || "Error"
    description = (
      <div>
        <div className="text-sm">{error.message}</div>
        {error.stack && (
          <details className="mt-2 whitespace-pre-wrap text-xs text-gray-500">
            <summary className="cursor-pointer">Stack trace</summary>
            {error.stack}
          </details>
        )}
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-lg w-full rounded-2xl bg-white shadow-sm ring-1 ring-gray-200 p-6">
        <div className="flex items-center gap-2 mb-3">
          <div className="h-8 w-8 rounded-lg bg-red-100 text-red-600 grid place-items-center">!</div>
          <h1 className="text-lg font-semibold">{title}</h1>
        </div>
        <div className="text-sm text-gray-700 mb-4">{description}</div>
        <div className="flex gap-2">
          <button
            onClick={() => window.location.assign("/")}
            className="px-3 py-2 rounded-md bg-blue-600 text-white text-sm"
          >
            Go Home
          </button>
          <button
            onClick={() => window.location.reload()}
            className="px-3 py-2 rounded-md border border-gray-300 text-sm"
          >
            Reload Page
          </button>
        </div>
      </div>
    </div>
  )
}
